import { playerDataIndex } from '~/search-domain/indexes';
import { buildPlayerDataQuery } from '~/search-domain/pipelines/player-data/build-query';
import {
  getPlayerDataBaseFilters,
  getPlayerDataFacetAttributes,
  getPlayerDataSearchSettings,
  getPlayerDataSorting,
} from '~/search-domain/pipelines/player-data/query-config';
import { transformPlayerDataResponse } from '~/search-domain/pipelines/player-data/transform-response';
import { type SearchPipelineDefinition, type SearchUiState } from '~/search-domain/types';

const resolvePlayerDataSorting = () => getPlayerDataSorting();

export const playerDataPipelineDefinition: SearchPipelineDefinition<SearchUiState, unknown> = {
  buildSearchRequest: buildPlayerDataQuery,
  facetAttributes: context => getPlayerDataFacetAttributes(context),
  getBaseFilters: context => getPlayerDataBaseFilters(context),
  getSearchUiConfig: () => ({
    searchAttributes: getPlayerDataSearchSettings().search ?? [],
    sorting: resolvePlayerDataSorting,
  }),
  getSorting: resolvePlayerDataSorting,
  id: playerDataIndex,
  searchSettings: () => getPlayerDataSearchSettings(),
  transformResponse: transformPlayerDataResponse,
};
